import { initContract } from '@ts-rest/core'
import z from 'zod'
import { Brand } from '../../shared'
import { ErrorResponseSchema } from '../../shared/types'
import { CancelReasonContext, CancelReasonSchema } from './cancelReason.schemas'

const c = initContract()

const options = {
  pathPrefix: '/cancel-reasons',
  commonResponses: {
    400: ErrorResponseSchema,
    500: ErrorResponseSchema,
    404: ErrorResponseSchema,
  },
}

export const cancelReasonServiceContract = c.router({
  getCancelReasons: {
    method: 'GET',
    path: '',
    query: z.object({
      context: z.nativeEnum(CancelReasonContext).default(CancelReasonContext.Subscription).optional(),
      brand: z.nativeEnum(Brand).default(Brand.LYKA).optional(),
    }),
    responses: {
      200: CancelReasonSchema.array(),
    },
  },
}, options)
